import React from 'react/addons';
import cx from 'classnames';
import {BackboneChangeMixin} from 'ofs/react/mixins';
import {gettext, interpolate} from 'ofs/i18n';

import Row from 'ofs/forms/layout/row';
import Column from 'ofs/forms/layout/column';

const messages = {
  HELP: gettext(`Can we help? Call %(guest_services_phone)s or email <a href="mailto:%(guest_services_email)s">%(guest_services_email)s</a>`),
  SAVE: gettext('Save and continue'),
};


module.exports = React.createClass({
  mixins: [BackboneChangeMixin],

  isValid: function(models) {
    return models.every(model => { return model.isValid(); });
  },

  render: function(){
    const {collection, model, models, email, phone} = this.props;

    // two different components use this component. This was part of a quick refactor to keep similar components together.
    var modelValid = model ? model.isValid() : this.isValid(models);
    var collectionValid = collection ? this.isValid(collection) : true;

    const allValid = collectionValid && modelValid;

    const classes = cx({
      'ofs-Button': true,
      'ofs-Button--full-width': true,
      'disabled': !allValid
    });

    return (
      <div className="ofs-Container">
        <div className="ofs-Container__Content">
          <div className="ofs-InfoPanel u-no-margin">
            <div className="ofs-Prestay__SaveButtonText" dangerouslySetInnerHTML={{__html: interpolate(messages.HELP, {guest_services_phone: phone, guest_services_email: email}, true)}}></div>
            <div className="ofs-Prestay__SaveButton">
              <button type="submit" className={classes} disabled={!allValid}>
              {messages.SAVE}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/SaveButton.jsx
 **/